import './style.css'
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import { useState, useEffect } from 'react';

export default function DateSelector({ label, onChange, date = null }) {
  const [value, setValue] = useState(dayjs(date || new Date()));

  useEffect(() => {
    if (date) {
      setValue(dayjs(date));
    }
  }, [date]);

  function handleChange(newValue) {
    setValue(newValue)
    onChange(newValue)
  }

  return (
    <div onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
      <DatePicker
        className='date-box'
        label={label}
        value={value}
        onChange={(newValue) => handleChange(newValue)}
        renderInput={(params) => <TextField {...params} />}
      />
    </div>
  );
}
